import React, { useEffect, useState } from "react";
import ProfileCard from "../../../components/UserSettings/ProfileCard";


import "./settings.css";
import ProfileForm from "../../../components/UserSettings/ProfileForm";
import BankInfo from "../../../components/UserSettings/BankInfo";
import ChangePin from "../Cards/CardOptions/ChangePin";
import ResetPin from "../../../components/UserSettings/Password/ResetPin";
import WorkUpdate from "../../../components/UserSettings/WorkUpdate";
import Compliance from "../../../components/UserSettings/Compliance";
import { useLocation } from "react-router-dom";
import Invitatations from "../../../components/UserSettings/Invitations";

const UserSettings = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "profile");
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  const hasPinSet = userDetails?.transaction_pin || false;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if(tab) setActiveTab(tab)
  }, [])

  return (
    <section className="main p-2 user_settings__page position-relative">
      <div className="container-fluid p-0">
        <div className="tabs mt-4 mb-3">
          <div className={`tab ${activeTab === "profile" ? "active" : ""}`} onClick={() => setActiveTab("profile")}>
            Profile
          </div>
          <div className={`tab ${activeTab === "compliance" ? "active" : ""}`} onClick={() => setActiveTab("compliance")}>
            Compliance
          </div>
          {userDetails?.account_type != 'business' && <div className={`tab ${activeTab === "invitations" ? "active" : ""}`} onClick={() => setActiveTab("invitations")}>
            Invitations
          </div>}
          {/* <div className={`tab ${activeTab === "bank" ? "active" : ""}`} onClick={() => setActiveTab("bank")}>
            Bank Account
          </div> */}
          <div className={`tab ${activeTab === "pin" ? "active" : ""}`} onClick={() => setActiveTab("pin")}>
            {hasPinSet ? "Change" : "Set"} Transfer Pin
          </div>
          <div className={`tab ${activeTab === "password" ? "active" : ""}`} onClick={() => setActiveTab("password")}>
            Reset Password
          </div>
          {/* <div className={`tab ${activeTab === "work" ? "active" : ""}`} onClick={() => setActiveTab("work")}>
            Work Information
          </div> */}
        </div>

        <div className="tab-content">
          {activeTab === "profile" && (
            <section className="profile-content container">
                <div className="row">
                    <div className="col-md-5 col-sm-12 my-3"> <ProfileCard userDetails={userDetails} /> </div>
                    <div className="col-md-7 col-sm-12 my-3"> <ProfileForm userDetails={userDetails} /> </div>
                </div>
            </section>
          )}


          {activeTab === "compliance" && ( <Compliance userDetails={userDetails} /> )}
          {activeTab === "invitations" && ( <Invitatations userDetails={userDetails} /> )}
          {activeTab === "bank" && ( <BankInfo userDetails={userDetails} /> )}
          {activeTab === "pin" && ( <ChangePin userDetails={userDetails} /> )}
          {activeTab === "password" && ( <ResetPin userDetails={userDetails} /> )}
          {/* {activeTab === "work" && ( <WorkUpdate userDetails={userDetails} /> )} */}
        </div>
      </div>
    </section>
  );
};

export default UserSettings;
